<template>
  <HTag :color="color">{{ label }}</HTag>
</template>
<script>
import { HTag } from '@/components/shared/atoms'
import { STAFF_STATUS, STAFF_STATUS_LABEL } from '@/models/channels'

export default {
  components: { HTag },
  props: {
    status: {
      type: String,
      default: STAFF_STATUS.UNAVAILABLE
    }
  },
  computed: {
    label() {
      return STAFF_STATUS_LABEL[this.status]
    },
    color() {
      if (this.status === STAFF_STATUS.UNAVAILABLE) {
        return 'red'
      }
      if (this.status === STAFF_STATUS.AVAILABLE) {
        return 'green'
      }
      return 'yellow'
    }
  }
}
</script>
